import {
  TechemModal,
  TechemModalBody,
  TechemModalButtonFooter,
  TechemModalHeader
} from '@techem/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DataProtectionContent from '../../../../presentation/components/shared/DataProtectionContent';
import { DocumentIdentifier } from '../../../../frameworks_drivers/localization/Localization';
import { TrackerUtil } from '../../../../tracking/TrackerUtil';

interface DataProtectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DataProtectionModal: React.FC<DataProtectionModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <TechemModal
      closeable
      isOpen={isOpen}
      modalTrackingId={'modal-data-privacy'}
      onClose={onClose}
      additionalTestId="data-privacy"
      header={
        <TechemModalHeader
          titleAlignment="start"
          title={t('content.title', {
            ns: DocumentIdentifier.DataProtection
          })}
        />
      }
      body={
        <TechemModalBody>
          <DataProtectionContent />
        </TechemModalBody>
      }
      footer={
        <TechemModalButtonFooter
          primary={{
            text: t('closeModalText'),
            handleOnClick: onClose,
            additionalTestId: 'close'
          }}
          trackClickUsingTestId={(buttonIdentifier) =>
            TrackerUtil.trackBtnClickByIdentifier(buttonIdentifier, 'modal-data-privacy')
          }
        />
      }
    />
  );
};

export { DataProtectionModal };
